<!-- Header -->
<mat-toolbar color="primary" class="custom-header">
  <!-- Menu Toggle -->
  <button
    mat-icon-button
    class="menu-toggle-header-button"
    (click)="onToggleSidenav()"
    matTooltip="Toggle Menu"
    matTooltipPosition="below"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <img [src]="logoUrl" alt="Logo" class="assistbot-logo" />
  <span class="heading-text">{{ appHeading }}</span>

  <!-- Spacer to push content to the right -->
  <span class="toolbar-spacer"></span>

  <!-- Header Content (Icons and Profile) -->
  <div class="header-actions">
    <a
      *ngIf="heading"
      (click)="navigateToProfile()"
      class="header-heading"
      >{{ heading }}</a
    >

    <button
      mat-icon-button
      (click)="showComingSoonMessage()"
      *ngIf="showSearch"
    >
      <mat-icon>search</mat-icon>
    </button>

    <button
      mat-icon-button
      (click)="showComingSoonMessage()"
      *ngIf="showNotifications"
    >
      <mat-icon>notifications</mat-icon>
    </button>
    
    <button
      mat-icon-button
      (click)="logout()"
      *ngIf="false"
      matTooltip="Logout"
      matTooltipPosition="below"
    >
      <mat-icon>logout</mat-icon>
    </button>

    <!-- User Menu Button -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      matTooltip="User Menu"
      matTooltipPosition="below"
      class="user-menu-trigger"
      [attr.aria-label]="'User menu for ' + userEmail"
      [attr.aria-expanded]="menuOpen"
      (menuOpened)="menuOpen = true"
      (menuClosed)="menuOpen = false"
    >
      <mat-icon>account_circle</mat-icon>
    </button>

    <mat-menu #userMenu="matMenu" class="user-menu-dropdown">
      <div class="user-menu-header">
        <mat-icon class="user-avatar">account_circle</mat-icon>
        <div class="user-info">
          <span class="user-email">{{ userEmail }}</span>
          <span class="user-role">{{ userRole || 'Member' }}</span>
        </div>
      </div>
      
      <mat-divider class="menu-divider"></mat-divider>

      <button mat-menu-item (click)="navigateToProfile()" class="menu-item">
        <mat-icon>person</mat-icon>
        <span class="menu-item-text">
          <span class="menu-item-title">Profile</span>
          <span class="menu-item-subtitle">Manage your account</span>
        </span>
      </button>

      <button mat-menu-item (click)="navigateToWorkspace()" class="menu-item">
        <mat-icon>workspaces</mat-icon>
        <span class="menu-item-text">
          <span class="menu-item-title">Workspace</span>
          <span class="menu-item-subtitle">Switch or manage workspaces</span>
        </span>
      </button>

      <mat-divider class="menu-divider"></mat-divider>

      <button mat-menu-item (click)="logout()" class="menu-item logout-item">
        <mat-icon>logout</mat-icon>
        <span class="menu-item-text">
          <span class="menu-item-title">Sign out</span>
        </span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
